// extracted by mini-css-extract-plugin
module.exports = {"title":"SearchResultsCount__title"};